import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withHandlers, withProps } from 'recompose';
import { compose } from 'redux';
import { cpdPointStatus, exportCpdActivityMap, getCpdActivityTitle, getCpdActivityTransform, kaplanMapping, mapCpdPoint } from '../../../../../constants';
import { getUserIndustryGoals } from '../../../../../services';
import { getCpdActivityColumns, mapCpdActivity } from '../../../../../services/cpd-activity';
import { downloadBlobStreamFile, getBlobStream, getCsvStream, writeDataToCsvStream } from '../../../../../utils';

const DownloadActivityButton = ({ exportCsv, exportKaplanHistoryCsv, hasImportedHistory }) => {
  return <div>
    <Button className='no-margin' bsStyle='plain' onClick={exportCsv}>Export CPD Activities</Button>
    {
      hasImportedHistory ?
        <Button className='no-margin' bsStyle='plain' onClick={exportKaplanHistoryCsv}>View Imported CPD History</Button> : null
    }
  </div>
}

const excludeCpdCategory = fp.filter(
  key => key !== 'cpdCategory'
)

const mapKaplanHistory = (cpdCategorys, publishers) =>
  fp.flow(
    fp.filter((cpdPoint) => cpdPoint.status !== cpdPointStatus.draft),
    fp.map(
      (cpdPoint) => {
        const cpdValues = fp.flow(
          fp.keys,
          excludeCpdCategory,
          fp.map(
            (key) => getCpdActivityTransform(key)(exportCpdActivityMap)(
              mapCpdPoint(cpdCategorys, publishers)(cpdPoint)
            )
          )
        )(exportCpdActivityMap)
        const documentedValues = fp.flow(
          fp.keys,
          fp.map(
            (kaplanName) => {
              const documentedPoints = fp.filter(
                ({ name }) => name === kaplanName
              )(cpdPoint.documentedCpdPoints)
              return fp.sumBy('points')(documentedPoints)
            }
          )
        )(kaplanMapping)
        const values = cpdValues.concat(documentedValues)
        return values
      }
    )
  );

const mapStateToProps = ({ industry, publisher, user, ...state }) => ({
  publishers: publisher.publishers,
  industriesWithCpdCategorys: fp.get('industriesWithCpdCategorys')(industry)
});

const mapDispatchToProps = (dispatch) => ({});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ industriesWithCpdCategorys, trainingPlans, cpdPoints }) => {
      const industryCpdCategorys = fp.flow(
        fp.map('industry'),
        fp.map(
          ({ id }) => {
            return fp.flow(
              fp.find(
                ({ industry }) => industry.id === id
              ),
              fp.get('cpdCategorys')
            )(industriesWithCpdCategorys)
          }
        ),
        fp.flatten
      )(trainingPlans)
      const sortedCpdPoints = fp.sortBy(
        ({ timeEarned }) => {
          const date = dateFnsCompat.parse(timeEarned).getTime() * -1
          return date
        }
      )(cpdPoints)
      const userIndustryGoals = getUserIndustryGoals({ trainingPlans }, industriesWithCpdCategorys)
      const hasImportedHistory = fp.filter(
        ({ documentedCpdPoints }) => documentedCpdPoints.length > 0
      )(cpdPoints).length > 0
      return {
        industryCpdCategorys,
        cpdPoints: sortedCpdPoints,
        hasImportedHistory,
        userIndustryGoals
      }
    }
  ),
  withHandlers(
    {
      exportCsv: ({ cpdPoints, industryCpdCategorys, publishers, userIndustryGoals }) => () => {
        const columns = getCpdActivityColumns(industryCpdCategorys, userIndustryGoals)
        const rows = mapCpdActivity(industryCpdCategorys, publishers, userIndustryGoals)(cpdPoints)

        downloadBlobStreamFile(
          writeDataToCsvStream(
            getCsvStream({
              header: true,
              columns
            }),
            rows
          ).pipe(
            getBlobStream()
          ),
          'cpd-activity.csv'
        );
      },
      exportKaplanHistoryCsv: ({ cpdPoints, industryCpdCategorys, publishers }) => () => {
        const cpdColumns = fp.flow(
          fp.keys,
          excludeCpdCategory,
          fp.map((key) => [key, getCpdActivityTitle(key)(exportCpdActivityMap)]),
          fp.fromPairs
        )(exportCpdActivityMap);
        const documentedColumns = fp.flow(
          fp.keys,
          fp.map((key) => [key, key]),
          fp.fromPairs
        )(kaplanMapping)
        const columns = {
          ...cpdColumns,
          ...documentedColumns
        }

        const kaplanCpdPoints = fp.filter(
          ({ documentedCpdPoints }) => documentedCpdPoints.length > 0
        )(cpdPoints)
        const rows = mapKaplanHistory(industryCpdCategorys, publishers)(kaplanCpdPoints)

        downloadBlobStreamFile(
          writeDataToCsvStream(
            getCsvStream({
              header: true,
              columns
            }),
            rows
          ).pipe(
            getBlobStream()
          ),
          'kaplan-history.csv'
        );
      }
    }
  )
)(DownloadActivityButton)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/user-portal/partial/download-activity-button.js